import React from 'react';
import HeroBanner from '../components/home/HeroBanner';
import FeaturedModule from '../components/home/FeaturedModule';
import AnalyticsModule from '../components/home/AnalyticsModule';
import CoreModules from '../components/home/CoreModules';
import './Home.css';

const Home = () => {
    React.useEffect(() => {
        document.title = "X-Max | Manufacturing Excellence Reimagined";
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <HeroBanner />

            {/* Trusted Companies Section */}
            <section className="container trusted-section">
                <p className="trusted-title">
                    Trusted by modern manufacturing teams
                </p>
                <div className="trusted-companies">
                    <div className="trusted-company">Company A</div>
                    <div className="trusted-company">Company B</div>
                    <div className="trusted-company">Company C</div>
                    <div className="trusted-company">Company D</div>
                    <div className="trusted-company">Company E</div>
                </div>
            </section>

            <CoreModules />

            <FeaturedModule />

            <AnalyticsModule />


        </>
    );
};

export default Home;
